import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { buildLoginForm } from '../user-login/user-login.form';

export interface LoginCredentials {
  username: string;
  password: string;
  remember: boolean;
}

@Component({
  selector: 'sw-user-login-form',
  templateUrl: './user-login-form.component.html',
  styleUrls: ['./user-login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserLoginFormComponent implements OnInit {
  @Input() isLoading = false;
  @Output() loginSubmit = new EventEmitter<LoginCredentials>();
  @Output() forgotPassword = new EventEmitter<string>();

  loginForm!: FormGroup;
  submitted = false;
  showResetPass = false;
  mailforgotten = '';

  // Controla la clase .shake en el template
  isShaking = false;

  private readonly fb = inject(FormBuilder);
  private readonly cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.loginForm = buildLoginForm(this.fb);
  }

  /** Devuelve true si el campo debe mostrar errores */
  fieldHasError(controlName: string): boolean {
    const ctrl = this.loginForm.get(controlName);
    if (!ctrl) return false;
    return ctrl.invalid && (ctrl.touched || this.submitted);
  }

  /** Devuelve true si el campo tiene un error concreto */
  fieldError(controlName: string, errorKey: string): boolean {
    const ctrl = this.loginForm.get(controlName);
    if (!ctrl) return false;
    return ctrl.hasError(errorKey) && (ctrl.touched || this.submitted);
  }

  onLogin(): void {
    this.submitted = true;
    this.cdr.markForCheck();

    if (this.loginForm.invalid) {
      // Formulario invalido: agitar la card para indicar error
      this.triggerShake();
      return;
    }

    const { username, password, remember } = this.loginForm.getRawValue() as LoginCredentials;
    this.loginSubmit.emit({ username, password, remember });
  }

  /** Llamado desde el padre cuando el submit falla en el servidor */
  triggerShake(): void {
    if (this.isShaking) return;
    this.isShaking = true;
    this.cdr.markForCheck();
    setTimeout(() => {
      this.isShaking = false;
      this.cdr.markForCheck();
    }, 600);
  }

  onForgotPassword(): void {
    this.forgotPassword.emit(this.mailforgotten);
    this.mailforgotten = '';
    this.showResetPass = false;
  }
}
